import { injectable } from '@servicetitan/react-ioc';
import { MultipleAccountData } from '../stores/login.store';
import axios, { AxiosRequestConfig, AxiosPromise, CancelToken } from 'axios';
import { makeCodedException } from 'utils';
import * as queryString from 'query-string';

export interface ILoginApi {
    login(returnUrl: string, data: any): AxiosPromise<string | boolean | MultipleAccountData[]>;
    fallbackLogin(data: any): AxiosPromise<string | boolean | MultipleAccountData[]>;
}

@injectable()
export class LoginApi implements ILoginApi {
    constructor(private readonly baseUrl?: string) {
        this.baseUrl = baseUrl || "";
    }

    login = (returnUrl: string, data: any, tenant?: string, cancelToken?: CancelToken): AxiosPromise<string | boolean | MultipleAccountData[]> => {
        let url = '/Auth/Login';
        if (!!returnUrl) {
            url += '?returnUrl=' + encodeURIComponent(returnUrl);
        }

        let requestHeaders: any;

        if (!!tenant && tenant.length > 0){
            requestHeaders = {
                "Content-Type": "application/x-www-form-urlencoded",
                "ST-Tenant": tenant
            }
        }
        else {
            requestHeaders = {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        }

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url,
            method: "POST",
            data: queryString.stringify(data),
            headers: requestHeaders
        }

        return makeCodedException(axios.request<string | boolean | MultipleAccountData[]>(options_));
    }

    fallbackLogin = (data: any, cancelToken?: CancelToken): AxiosPromise<string | boolean | MultipleAccountData[]> => {
        let url = '/api/v1/fallbacklogin';

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url,
            method: "POST",
            data: data,
        }

        return makeCodedException(axios.request<string | boolean | MultipleAccountData[]>(options_));
    }
}
